/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  DatasetResponse,
  DatasetResponse$inboundSchema,
  DatasetResponse$Outbound,
  DatasetResponse$outboundSchema,
} from "./datasetresponse.js";

export type GetDatasetsResponse = {
  success?: true | undefined;
  data: Array<DatasetResponse>;
};

/** @internal */
export const GetDatasetsResponse$inboundSchema: z.ZodType<
  GetDatasetsResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  success: z.literal(true).default(true).optional(),
  data: z.array(DatasetResponse$inboundSchema),
});

/** @internal */
export type GetDatasetsResponse$Outbound = {
  success: true;
  data: Array<DatasetResponse$Outbound>;
};

/** @internal */
export const GetDatasetsResponse$outboundSchema: z.ZodType<
  GetDatasetsResponse$Outbound,
  z.ZodTypeDef,
  GetDatasetsResponse
> = z.object({
  success: z.literal(true).default(true as const),
  data: z.array(DatasetResponse$outboundSchema),
});

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetDatasetsResponse$ {
  /** @deprecated use `GetDatasetsResponse$inboundSchema` instead. */
  export const inboundSchema = GetDatasetsResponse$inboundSchema;
  /** @deprecated use `GetDatasetsResponse$outboundSchema` instead. */
  export const outboundSchema = GetDatasetsResponse$outboundSchema;
  /** @deprecated use `GetDatasetsResponse$Outbound` instead. */
  export type Outbound = GetDatasetsResponse$Outbound;
}

export function getDatasetsResponseToJSON(
  getDatasetsResponse: GetDatasetsResponse,
): string {
  return JSON.stringify(
    GetDatasetsResponse$outboundSchema.parse(getDatasetsResponse),
  );
}

export function getDatasetsResponseFromJSON(
  jsonString: string,
): SafeParseResult<GetDatasetsResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetDatasetsResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetDatasetsResponse' from JSON`,
  );
}
